<template>
  <div>
    <div v-if="project.members.length">
      <v-card color="transparent" flat v-if="project.clients.length">
        <v-card-title class="subtitle-1">Project - clients</v-card-title>

        <v-card-text class="pa-0">
          <v-card
            outlined
            v-for="member in project.clients"
            :key="member.id"
            class="mb-2"
          >
            <v-card-text>
              <v-row align="center">
                <v-col>
                  <div class="subtitle-2">{{ member.name }}</div>
                  <div>{{ member.email }}</div>
                </v-col>
                <v-col align="right">
                  <v-btn
                    text
                    :loading="loading.memberById == member.id"
                    v-if="$can('projects.members.manage')"
                    @click="remove(member.id)"
                    :disabled="member.id == $authUser.id"
                    >Remove</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card color="transparent" flat v-if="project.managers.length">
        <v-card-title class="subtitle-1">Project - managers</v-card-title>

        <v-card-text class="pa-0">
          <v-card
            outlined
            v-for="member in project.managers"
            :key="member.id"
            class="mb-2"
          >
            <v-card-text>
              <v-row align="center">
                <v-col>
                  <div class="subtitle-2">{{ member.name }}</div>
                  <div>{{ member.email }}</div>
                </v-col>
                <v-col align="right">
                  <v-btn
                    text
                    :loading="loading.memberById == member.id"
                    v-if="$can('projects.members.manage')"
                    @click="remove(member.id)"
                    :disabled="member.id == $authUser.id"
                    >Remove</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card color="transparent" flat v-if="project.workers.length">
        <v-card-title class="subtitle-1">Project - workers</v-card-title>

        <v-card-text class="pa-0">
          <v-card
            outlined
            v-for="member in project.workers"
            :key="member.id"
            class="mb-2"
          >
            <v-card-text>
              <v-row align="center">
                <v-col>
                  <div class="subtitle-2">{{ member.name }}</div>
                  <div>{{ member.email }}</div>
                </v-col>
                <v-col align="right">
                  <v-btn
                    text
                    :loading="loading.memberById == member.id"
                    v-if="$can('projects.members.manage')"
                    @click="remove(member.id)"
                    :disabled="member.id == $authUser.id"
                    >Remove</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card color="transparent" flat v-if="project.invitations.length">
        <v-card-title class="subtitle-1">Pending invitations</v-card-title>

        <v-card-text class="pa-0">
          <v-card
            outlined
            v-for="invitation in project.invitations"
            :key="invitation.id"
            class="mb-2"
          >
            <v-card-text>
              <v-row align="center">
                <v-col>
                  <div class="subtitle-2">{{ invitation.name }}</div>
                  <div>{{ invitation.email }}</div>
                </v-col>
                <v-col align="right">
                  <v-row justify="end" no-gutters>
                    <v-btn
                      text
                      v-if="$can('projects.members.manage')"
                      @click="resendInvite(invitation.id)"
                      >Resend</v-btn
                    >

                    <v-btn
                      text
                      :loading="invitationLoading == invitation.id"
                      v-if="$can('projects.members.manage')"
                      @click="cancelInvitation(invitation.id)"
                      >Cancel</v-btn
                    >
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </div>

    <v-card outlined v-else>
      <v-card-title class="subtitle-1"
        >No members currently assigned to this project.</v-card-title
      >
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { alertConfirm } from '@/utilities/sweetalert'

export default {
  name: 'ProjectMembersList',
  computed: {
    ...mapState('projects', ['project', 'loading']),
    ...mapState('users', ['invitationLoading'])
  },
  methods: {
    ...mapActions('projects', ['removeProjectMember']),
    ...mapActions('users', ['cancelInvite', 'resendInvite']),
    remove(user_id) {
      alertConfirm(
        {
          title: 'Are you sure you want to remove this member?'
        },
        () => {
          if (!this.project) return

          this.removeProjectMember({
            project_id: this.project.id,
            user_id
          })
        }
      )
    },
    cancelInvitation(invitation_id) {
      alertConfirm(
        {
          title: 'Are you sure you want to cancel this invitation?'
        },
        () => {
          if (!this.project) return

          this.cancelInvite({
            id: invitation_id,
            project_id: this.project.id
          })
        }
      )
    }
  }
}
</script>
